export default "__VITE_ASSET__B6fD$RWR__"